module.exports = __webpack_public_path__ + "img/重庆开州汉丰湖国家湿地公园@2x.c8b0e876.png";